// Phase 136 — shared submittal presentation helpers.

export const SUBMITTAL_STATUS_META = {
  pending_review: { label: "Pending review", cls: "border-sky-500/30 bg-sky-500/10 text-sky-300" },
  approved: { label: "Approved", cls: "border-emerald-500/30 bg-emerald-500/10 text-emerald-300" },
  approved_with_comments: { label: "Approved with comments", cls: "border-emerald-500/30 bg-emerald-500/10 text-emerald-300" },
  revise_resubmit: { label: "Revise & resubmit", cls: "border-amber-500/40 bg-amber-500/10 text-amber-300" },
  rejected: { label: "Rejected", cls: "border-destructive/40 bg-destructive/10 text-destructive" },
};

export const SUBMITTAL_TYPES = [
  { key: "shop_drawings", label: "Shop drawings" },
  { key: "product_data", label: "Product data" },
  { key: "material_sample", label: "Material / sample" },
  { key: "method_statement", label: "Method statement / SWMS" },
  { key: "certificate", label: "Certificate / compliance" },
  { key: "other", label: "Other" },
];

export const DECISIONS = [
  { key: "approved", label: "Approved", hint: "Proceed — no changes needed" },
  { key: "approved_with_comments", label: "Approved with comments", hint: "Proceed, incorporating the comments" },
  { key: "revise_resubmit", label: "Revise & resubmit", hint: "Changes required — a new revision is expected" },
  { key: "rejected", label: "Rejected", hint: "Not accepted — stop and contact the builder" },
];

export const fmtBytes = (n) => {
  const b = Number(n) || 0;
  if (b < 1024) return `${b} B`;
  if (b < 1024 * 1024) return `${Math.max(1, Math.round(b / 1024))} KB`;
  return `${(b / (1024 * 1024)).toFixed(1)} MB`;
};

export const fmtStamp = (iso) => {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleString("en-AU", { day: "numeric", month: "short", year: "numeric", hour: "numeric", minute: "2-digit" });
  } catch {
    return iso;
  }
};

export const ACCEPT = ".pdf,.png,.jpg,.jpeg,.webp,.heic,.dwg,.dxf,.ifc,.doc,.docx,.xls,.xlsx,.csv,.txt,.zip";
